import { render } from "./EditEmail.vue?vue&type=template&id=90b546ca&ts=true"
import script from "./EditEmail.vue?vue&type=script&lang=ts"
export * from "./EditEmail.vue?vue&type=script&lang=ts"

import "./EditEmail.vue?vue&type=style&index=0&id=90b546ca&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__